import common from "../common.js";

export default {
  getProperties(state) {
    return state.properties;
  },
  // The container endpoints return whichever name suits the user's unit system,
  // so a name is not something history rows can be matched on. propertyId is
  // the same in both, and the master list is the only place that still knows
  // both names -- so callers name the property the metric way and match on the
  // ids that come back. Each container type carries its own copy of a property
  // (a bulk tank's "Volume (L)" is not a tank's), so every match is returned;
  // a container's history only holds its own type's, so any of them will do.
  // Empty when the property is not in the list.
  getPropertyIdsByName: (state) => (metricName) => {
    if (!Array.isArray(state.properties)) return [];
    return state.properties
      .filter((p) => common.isProperty(p, metricName))
      .map((p) => p.propertyId);
  },
  getHeaderProperties(state){
      var containerTypeId = 1;    
      if(state.properties==undefined || state.properties.length==0) return []
      return state.properties.filter(x=> x.showHeader && x.appliesTo=="C" && x.containerTypeId == containerTypeId);
  },
  // Volumes, fills and injections are all carried in the same unit, and the
  // API already named the Volume property for it. Falls back to litres before
  // the master list has loaded.
  getVolumeUnit(state) {
    if (!Array.isArray(state.properties)) return "L";
    const prop = state.properties.find((p) =>
      common.isProperty(p, "Volume (L)")
    );
    return prop ? common.unitOf(prop.propertyName) || "L" : "L";
  },
  getPropertyLists(state) {
    return state.propertyLists;
  },
  getCurrentPropertyList(state) {
    return state.propertyList;
  },
  getResponseCode(state) {
    return state.responseCode;
  },
  getProducts(state) {
    return state.products;
  },
};
